import axios from 'axios'
import env from '../env'

/** 后厨相关API */
export default class KitchenApi {
  static async getPickUpCode (para: any) {
    const Url: string = `${env.KITCHEN}/order/pickUpCode`
    const res: any = await axios.post(Url, para)
    return res.error ? res : res.result
  }
}
